import InvestmentHistoryWidget from './InvestmentHistoryWidget'

export default InvestmentHistoryWidget
